import React, { useState, useEffect } from "react";
import LayoutIcon from "src/components/icons/miscs/layout";
import AddIcon from "src/components/icons/common/add-icon";
import { useAppSelector, useAppDispatch } from "src/hooks/redux";
import TrashIconTwo from "src/assets/images/TrashTwo.svg";
import BookIcon from "src/assets/images/book.svg";
import SwitchIcon from "src/assets/images/switch.svg";
import { updatePitchdeckData } from "src/stores/vs-product";

interface Props {
  dataSource: string[];
  disabled?: boolean;
  updateUserInput?: (value: string) => void;
  answer?: string;
}
const Keywords: React.FC<Props> = (props) => {
  const {
    dataSource,
    disabled,
    updateUserInput = () => {
      undefined;
    },
    answer,
  } = props;
  const dispatch = useAppDispatch();

  const [items, setItems] = useState<string[]>(dataSource);
  const [newItem, setNewItem] = useState("");
  const [isInputVisible, setIsInputVisible] = useState(false);
  const [open, setOpen] = useState(true);
  const [additionalDataSources, setadditionalDataSources] = useState<string[]>([]);

  useEffect(() => {
    // setItems(DataSources);
    dispatch(updatePitchdeckData({ additionalKeywords: additionalDataSources }));
  }, [additionalDataSources]);

  const handleDelete = (index: number) => {
    if (index >= 0 && index < items.length) {
      const updatedSources = items.filter((_, i) => i !== index);
      setItems(updatedSources);
    } else {
      console.log("Invalid index");
    }
  };

  const handleDeleteAdditional = (index: number) => {
    if (index >= 0 && index < additionalDataSources.length) {
      const updatedSources = additionalDataSources.filter((_, i) => i !== index);
      if (answer) {
        const parts = answer
          .split(",")
          .map((s) => s.trim())
          .filter(Boolean);
        const updated = parts.filter((part) => part !== additionalDataSources[index]);
        updateUserInput(updated.join(", "));
      }
      setadditionalDataSources(updatedSources);
    } else {
      console.log("Invalid index");
    }
  };

  const handleAdd = () => {
    if (newItem.trim()) {
      setadditionalDataSources([...additionalDataSources, newItem.trim()]);
      setNewItem("");
      if (!answer?.trim()) {
        updateUserInput(newItem.trim());
      } else {
        updateUserInput(`${answer}, ${newItem.trim()}`);
      }

      setIsInputVisible(false);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      handleAdd();
    }
  };

  return (
    <div
      className={`border border-gray-300 rounded-lg w-full mb-[70px] overflow-y-auto ${
        open
          ? "flex-[0_0_100%] sm:flex-[0_0_75%] lg:flex-[0_0_460px] max-w-full lg:max-w-[460px]"
          : "flex-[0_0_100%] sm:flex-[0_0_215px] max-w-full sm:max-w-[215px]"
      }`}
    >
      <div
        className={`p-2 lg:p-4 ${
          open ? "w-full h-full" : "w-full h-auto"
        } bg-opacity-50 rounded-lg`}
      >
        <div className="flex">
          <div className="cursor-pointer py-1">
            <img src={BookIcon} alt="book" className="w-4" />
          </div>
          <div className="ml-2">
            <div className="flex justify-between">
              <h2 className="text-lg font-semibold">Auto-Suggested Keywords</h2>
              <div
                onClick={() => setOpen(!open)}
                className="cursor-pointer rounded border border-[#DFE3E8] p-1"
              >
                <img src={SwitchIcon} alt="book" className="w-[20px]" />
              </div>
            </div>
            {open && (
              <>
                <h4 className="mb-2 text-sm sm:text-base">
                  Customize sections to suit your needs.
                </h4>
              </>
            )}
          </div>
        </div>
        {open && (
          <div className="flex flex-col gap-y-2 h-[90%] lg:max-h-[70vh] lg:h-auto pb-2">
            <div className="h-[50vh] md:h-[70vh] pn_scroller overflow-y-auto p-2">
              {items.map((item, index: number) => (
                <div
                  key={item}
                  className="flex items-center py-1 border border-gray-300 rounded-lg mb-2 p-1 gap-1 justify-between"
                >
                  <a
                    className="flex-auto break-all leading-tight text-xs sm:text-sm text-blue-700"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item}
                  </a>
                  {disabled ? null : (
                    <button
                      className="text-red-500 flex-[0_0_20px]"
                      onClick={() => handleDelete(index)}
                    >
                      <img src={TrashIconTwo} alt="Delete" className="w-4 h-4" />
                    </button>
                  )}
                </div>
              ))}
              {additionalDataSources.map((item, index: number) => (
                <div
                  key={item}
                  className="flex items-center py-1 border border-gray-300 rounded-lg mb-2 p-1 gap-1 justify-between bg-orange-50 "
                >
                  <a
                    className="flex-auto break-all leading-tight text-xs sm:text-sm text-blue-700"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item}
                  </a>
                  {disabled ? null : (
                    <button
                      className="text-red-500 flex-[0_0_20px]"
                      onClick={() => handleDeleteAdditional(index)}
                    >
                      <img src={TrashIconTwo} alt="Delete" className="w-4 h-4" />
                    </button>
                  )}
                </div>
              ))}
            </div>
            {disabled ? null : (
              <div className="flex justify-between items-center py-1 border border-gray-300 rounded-lg mb-2 p-1">
                {isInputVisible && (
                  <input
                    type="text"
                    className="border border-gray-300 p-1 rounded-lg flex-grow w-full text-xs sm:text-sm placeholder:text-appGray-600 focus:outline-none focus:ring-0"
                    placeholder="Add new item"
                    value={newItem}
                    onChange={(e) => setNewItem(e.target.value)}
                    onKeyDown={handleKeyDown}
                  />
                )}
                <button
                  className={`flex items-center justify-start text-primary-900 ${
                    isInputVisible ? "hidden" : ""
                  }`}
                  onClick={() => setIsInputVisible(!isInputVisible)}
                >
                  {!isInputVisible && (
                    <>
                      <AddIcon color="#442873" size={25} />
                      <span className="text-xs sm:text-sm">Add</span>
                    </>
                  )}
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Keywords;
